<template>
  <div v-show="editShow">
    <div class="container">
      <el-row :gutter="20">
        <div class="clearfix">
          <div class="crumbs">
            <i class="el-icon-back"></i>
            <el-button type="text" @click="goBack()">返回</el-button>
          </div>
          <div class="btn-save">
            <el-button type="primary" @click="saveClick('ruleForm')"
            >保存
            </el-button
            >
          </div>
        </div>
        <div class="form-box">
          <el-form
              :model="ruleForm"
              :rules="rules"
              ref="ruleForm"
              label-width="120px"
              class="eidt-el-form"
          >
            <el-form-item label="禁用状态" prop="disabled">
              <el-select placeholder="禁用：" v-model="ruleForm.disabled">
                <el-option value="0" label="启用"></el-option>
                <el-option value="1" label="禁用"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="注册通道" prop="registerId">
              <el-select
                  placeholder="注册通道："
                  clearable
                  v-model="ruleForm.registerId"
                  class="el-input-position"
                  @change="handleChange($event)"
              >
                <el-option
                    v-for="(item, index) in registers"
                    :key="index"
                    :value="item.registerId"
                    :label="item.name"
                    @click="select(item)"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item prop="documentTypeId" label="证件类型">
              <el-select
                  v-model="ruleForm.documentTypeId"
                  placeholder="证件类型"
                  disabled
              >
                <el-option
                    v-for="(type, index) in DocumentType"
                    :label="type.name"
                    :key="index"
                    :value="type.documentTypeId"
                >{{ type.name }}
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="类型名称" prop="typeName">
              <el-input v-model="ruleForm.typeName" readonly="readonly"></el-input>
            </el-form-item>
            <el-form-item label="人员总数" prop="total">
              <el-input-number v-model="ruleForm.total" :min="1" type="number"></el-input-number>
            </el-form-item>
            <el-form-item label="团组名" prop="name">
              <el-input v-model="ruleForm.name"></el-input>
            </el-form-item>
            <el-form-item label="手机号" prop="phone">
              <el-input v-model="ruleForm.phone"></el-input>
            </el-form-item>
            <el-form-item label="邀请码" prop="inviteCode">
              <el-input v-model="ruleForm.inviteCode"></el-input>
            </el-form-item>
            <el-form-item label="账号" prop="userName">
              <el-input v-model="ruleForm.userName"></el-input>
            </el-form-item>
            <el-form-item label="密码" prop="password">
              <el-input v-model="ruleForm.password"></el-input>
            </el-form-item>
          </el-form>
        </div>
      </el-row>
    </div>
  </div>
</template>

<script>
import UploadImg from "../public/UploadImg";
import checkPhone from "../common/checkPhone";

export default {
  name: "editGroupUser",
  data() {
    return {
      rules: {
        name: [{required: true, message: "团组名不能为空", trigger: "blur"}],
        password: [{required: true, message: "密码不能为空", trigger: "blur"}],
        typeName: [{required: true, message: "类型名称不能为空", trigger: "blur"}],
        inviteCode: [
          {required: true, message: "邀请码不能为空", trigger: "blur"},
        ],
        userName: [
          {required: true, message: "账号不能为空", trigger: "blur"},
        ],
        total: [
          {required: true, message: "总数不能为空", trigger: "blur"},
        ],
        disabled: [
          {required: true, message: "禁用不能为空", trigger: "blur"},
        ],
        phone: [{required: true, validator: checkPhone, trigger: "blur"}],
        documentTypeId: [
          {required: true, message: "证件类型不能为空", trigger: "blur"},
        ],
        registerId: [{required: true, message: "注册通道不能为空", trigger: "blur"}],
      },
      DocumentType: [],
      registers: [],
      ruleForm: {
        name: "",
        inviteCode: "",
        phone: "",
        userName: "",
        password: "",
        total: "1",
        disabled: "0",
        typeName: "",
        registerId: "",
        documentTypeId: "",
        projectId: localStorage.getItem("project_Id"),
      },
      projectId: localStorage.getItem("project_Id"),
      editImg: "",
      groupUserId: "",
      imgTitle: "上传头像",
    };
  },
  props: {
    editShow: {
      type: Boolean,
      default: false,
    },
    editData: {
      type: Object,
    },
  },
  created() {
    this.$axios.get("/DocumentType/Project/" + this.projectId).then((res) => {
      if (res.data.hasError == false) {
        this.DocumentType = [...res.data.data];
      }
    });

    this.$axios
        .get("/Register/Project/" + this.projectId)
        .then((res) => {
          if (res.data.hasError == false) {
            this.registers = [...res.data.data];
          } else {
            console.log(res.data.message);
          }
        })
        .catch(function () {
        });
  },
  watch: {
    $route: "getPath",
    editData: function () {
      const item = this.editData;
      if (item) {
        this.ruleForm = this.editData;
        this.groupUserId = item.groupUserId;
        this.ruleForm.disabled = item.disabled.toString();
      }
    },
  },
  methods: {
    handleChange(e) {
      this.registers.forEach(item => {
        if (item.registerId == e) {
          this.ruleForm.documentTypeId = item.documentTypeId;
          this.ruleForm.typeName = item.name;
          return;
        }
      })
    },
    select(item) {
      this.ruleForm.documentTypeId = item.documentTypeId
    },
    saveClick(ruleForm) {
      this.$refs[ruleForm].validate((valid) => {
        if (valid) {
          if (this.groupUserId == "" || this.groupUserId == undefined) {
            this.$axios.post("/GroupUser/", this.ruleForm).then((res) => {
              if (res.data.hasError == false) {
                this.$message.success("保存成功！");
                this.goBack();
              } else {
                this.$message.error(res.data.message);
              }
            });
          } else {
            this.$axios
                .put("/GroupUser/" + this.groupUserId + "", this.ruleForm)
                .then((res) => {
                  if (res.data.hasError == false) {
                    this.$message.success("编辑成功！");
                    this.goBack();
                  } else {
                    this.$message.error(res.data.message);
                  }
                });
          }
        } else {
          return false;
        }
      });
    },
    goBack() {
      this.ruleForm = {
        name: "",
        inviteCode: "",
        phone: "",
        userName: "",
        password: "",
        total: "1",
        disabled: "0",
        typeName: "",
        registerId: "",
        documentTypeId: "",
        projectId: localStorage.getItem("project_Id"),
      };
      this.$emit("backFunStu");
      this.groupUserId = "";
      this.$refs.ruleForm.resetFields();
    },
    getUploadImg(imgSrc) {
      this.ruleForm.avatar = imgSrc;
    },
  },
  components: {
    UploadImg,
  },
};
</script>